module.exports = __webpack_public_path__ + "assets/angle-down.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/angle-down.png
// module id = 1655
// module chunks = 7